import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Logo from 'components/logo/logo';
import {loginUiTexts} from 'data/ui-texts';
import {gamesArray, gamesData} from 'data/games-data';
import {getText} from 'helpers/language-helper';
import aeroteam from 'assets/images/aeroteam.png';
import sagroup from 'assets/images/sagroup.png';
import cglLogo from 'assets/images/logo-cgl.svg';
import './landing-page.scss';
// TODO: 'en'- > languageId
const LandingPage = ({company}) => {
	return (
		<div className={'LandingPage' + (company ? ' ' + company.id : '')}>
			<img src={aeroteam} className="aeroteam" alt="aeroteam logo" />
			<img src={sagroup} className="sagroup" alt="sa-group logo" />
			<Logo classes={['landingpage']}/>
			<div className="LandingPage-games">
				{gamesArray.map((gameId, index) => {
					if (!gamesData.hasOwnProperty(gameId)) return null;
					let linkTo = gamesData[gameId].urlPath;
					if (company) {
						linkTo = '/' + company.loginConfig.url + gamesData[gameId].urlPath;
					}
					return (
						<Link key={index} to={linkTo} className={'LandingPage-game ' + gameId}>
							<div className="LandingPage-gameTitle">
								{getText(gamesData[gameId].titleLandingPage, 'en')}
							</div>
						</Link>
					);
				})}
			</div>
			<Link to="/admin" className="LandingPage-adminBtn">{getText(loginUiTexts.adminBtn, 'en')}</Link>
			<div className='LandingPage-logo' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}} >
				<img src={cglLogo} alt="Læringsspil udviklet af Copenhagen Game Lab" />
			</div>
		</div>
	);
};


LandingPage.propTypes = {
	company: PropTypes.object,
};


export default LandingPage;